<template>
  <div class="unit" :class="{ collapsed: unit.collapsed, parent: hasChildren || hasSubjects }">
    <TrainingModelRowComponent
      ref="unitRow"
      :entity="unit"
      :level="1"
      @collapse="collapse"
      @edit="edit"
      @removed="removed"
      @hideComplete="hideComplete"
    />
    <div
      class="unit__collapse"
      v-if="hasChildren || hasSubjects"
      :style="'--max-height: ' + countRow * (rowHeight() ? rowHeight() : 51) + 'px;'"
    >
      <VueDraggableNext
        :animation="200"
        :delay="200"
        :delay-on-touch-only="true"
        :list="unit.childTrainingUnits"
        handle=".entity__grip"
        @change="sortUnits"
      >
        <template v-for="child in unit.childTrainingUnits" :key="child.id">
          <TrainingModelRowComponent
            :entity="child"
            :level="2"
            :parent="unit"
            @edit="edit"
            @removed="removed"
            @hideComplete="hideComplete"
          />
          <VueDraggableNext
            :animation="200"
            :delay="200"
            :delay-on-touch-only="true"
            :list="child.trainingSubjects"
            handle=".entity__grip"
            @change="sortSubjects"
          >
            <template v-for="subSubject in child.trainingSubjects" :key="subSubject.id">
              <TrainingModelRowComponent
                :entity="subSubject"
                :level="3"
                type="subject"
                :parent="child"
                @edit="edit"
                @removed="removed"
                @hideComplete="hideComplete"
              />
            </template>
          </VueDraggableNext>
        </template>
      </VueDraggableNext>
      <VueDraggableNext
        :animation="200"
        :delay="200"
        :delay-on-touch-only="true"
        :list="unit.trainingSubjects"
        handle=".entity__grip"
        @change="sortSubjects"
      >
        <template v-for="subject in unit.trainingSubjects" :key="subject.id">
          <TrainingModelRowComponent
            :entity="subject"
            :level="2"
            type="subject"
            :parent="unit"
            @edit="edit"
            @removed="removed"
            @hideComplete="hideComplete"
          />
        </template>
      </VueDraggableNext>
    </div>
  </div>
</template>

<script>
import { trainingManager } from "@/services/training/training-manager";
import { stringManager } from "@/services/utilities/string-manager";
import TrainingModelRowComponent from "@/components/training/model/TrainingModelRowComponent.vue";
import { VueDraggableNext } from "vue-draggable-next";

export default {
  name: "TrainingUnitComponent",
  components: { VueDraggableNext, TrainingModelRowComponent },
  emits: ["edit", "removed", "hideComplete"],
  props: {
    unit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      isExpanded: true,
    };
  },
  computed: {
    hasChildren() {
      return this.unit.childTrainingUnits && Object.keys(this.unit.childTrainingUnits).length;
    },

    hasSubjects() {
      return this.unit.trainingSubjects && Object.keys(this.unit.trainingSubjects).length;
    },

    countRow() {
      return 1 + (this.hasSubjects ? this.hasSubjects : 0) + (this.hasChildren ? this.hasChildren : 0);
    },

    isWarning() {
      return this.unit.confidence < 75;
    },
  },
  methods: {
    stringManager() {
      return stringManager;
    },

    edit(payload) {
      this.$emit("edit", payload);
    },

    rowHeight() {
      if (this.$refs.unitRow && this.$refs.unitRow.offsetHeight) {
        return this.$refs.unitRow.offsetHeight;
      }
    },

    removed(payload) {
      this.$emit("removed", payload);
    },

    hideComplete(payload) {
      this.$emit("hideComplete", payload);
    },

    collapse(entity) {
      entity["collapsed"] = !entity["collapsed"];
    },

    sortSubjects(e) {
      this.sort(e, "subject");
    },

    sortUnits(e) {
      this.sort(e, "unit");
    },

    sort(e, type) {
      if (e.moved) {
        const id = e.moved.element.id;
        const position = e.moved.newIndex;
        trainingManager.sort(id, this.$route.params.trainingId, position, type, type);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.unit {
  &.parent {
    border-left: 4px solid $blue;
  }

  &__collapse {
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
    max-height: var(--max-height);
  }

  &.collapsed {
    .unit__collapse {
      max-height: 0;
    }
  }
}
</style>
